import { useFormContext } from '@calendly/form';
import { useCallback } from 'react';
import { MAX_LOCATIONS } from 'components/event_type_edit/location_v3/constants';
import { useLocationManagement, useLocationSettings } from 'components/event_type_edit/location_v3/hooks';
import { useAvailableKinds } from 'components/event_type_edit/location_v3/hooks/use_availabile_kinds';
import { getIsRROrCRRWithoutCollectivePools, getUserPools } from 'components/event_type_edit/location_v3/utils';
import { MANAGED_EVENT_TYPE } from 'constants/event_types';
import { EventTypeEditorLocationField } from 'features/event_type_editor';
import { useEventTypeContext } from 'features/event_type_provider';
import { useETEditorFormikPoolingType } from 'services/event_types';
import { AddAnotherLocationOption, LocationSelectButtons, SelectedLocationItem } from './location';
const listCss = "lf6ivbo";

/** Shows CRUD-styled location buttons when no location is set; defers to the shared field otherwise. */
export const CrudLocationChooser = ({
  isLocked,
  isReadOnly
}) => {
  const {
    eventType
  } = useEventTypeContext();
  const {
    isGroup,
    isPoll
  } = eventType;
  const {
    isRoundRobin,
    isCollective,
    isCollectiveRoundRobin
  } = useETEditorFormikPoolingType();
  const {
    values
  } = useFormContext();
  const {
    memberships
  } = values;
  const membership = memberships?.[0];
  const userPools = getUserPools(values);
  const useRoundRobinLayout = getIsRROrCRRWithoutCollectivePools(isRoundRobin, isCollectiveRoundRobin, userPools);
  const {
    filteredLocations,
    addLocation
  } = useLocationManagement(eventType, membership);
  const [possibleKinds, showIntegrationErrors] = useLocationSettings(eventType, userPools, true, eventType.isMETParent, false);
  const availableKinds = useAvailableKinds(possibleKinds, filteredLocations);
  const canCollectiveHaveMultipleLocations = isCollective || userPools.some(pool => pool.pooling_type === 'collective');
  const allowMultiple = eventType.kind_name === 'one_on_one' || eventType.type === MANAGED_EVENT_TYPE && eventType.kind === 'solo' || canCollectiveHaveMultipleLocations;
  const shouldDisableOutbound = isGroup || isPoll;
  const handleAddLocation = useCallback(kind => {
    addLocation(kind, allowMultiple);
  }, [addLocation, allowMultiple]);
  const showCrudButtons = !useRoundRobinLayout && !isReadOnly && filteredLocations.length === 0;
  const showCrudSelectedLocations = !useRoundRobinLayout && !isReadOnly && filteredLocations.length > 0;
  if (showCrudButtons) {
    return <LocationSelectButtons onChange={handleAddLocation} availableKinds={availableKinds} shouldDisableOutbound={shouldDisableOutbound} />;
  }
  if (showCrudSelectedLocations) {
    const canAddMoreLocations = allowMultiple && filteredLocations.length < MAX_LOCATIONS;
    return <div className={listCss} data-calendly-label="event-details-location">
        {filteredLocations.map(location => <SelectedLocationItem key={location.id || location.nanoId} location={location} membership={membership} eventType={eventType} shouldDisableOutbound={shouldDisableOutbound} showIntegrationErrors={showIntegrationErrors} />)}
        {canAddMoreLocations && <AddAnotherLocationOption onSelect={handleAddLocation} possibleKinds={possibleKinds} filteredLocations={filteredLocations} />}
      </div>;
  }
  return <EventTypeEditorLocationField isLocked={isLocked} isReadOnly={isReadOnly} />;
};

require("./crud_location_chooser.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./crud_location_chooser.js");